<ng-container *transloco="let t; read: 'onlinetest'">
  <div class="main-content" *ngIf="onlinetest !== null">
    <app-content-header
      [title]="t('onlinetest') +': ' + onlinetest.fullname"
    ></app-content-header>

    <div class="layout-content">
      <app-close-button></app-close-button>
      <div class="acr-card-body">

        <app-candidate-selector
          [candidate]="candidate"
          (candidateChange)="changeCandidate($event)"
        ></app-candidate-selector>

        <div class="rating-container">

          <app-onlinetest-nav
            [ac]="ac"
            [onlinetest]="onlinetest"
            [candidate]="candidate"
          ></app-onlinetest-nav>

          <div class="rating-content">

            <p-table [value]="competences" dataKey="id" styleClass="p-datatable-sm">

              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 3rem"></th>
                  <th>{{ t("competence_behavioranchor") }}</th>
                  <th>{{ t("rating") }}</th>
                  <ng-container *ngIf="auth.isModerator() && withObservers && foreignRatings !== null">
                    <ng-container *ngFor="let observer of ac.observers">
                      <ng-container *ngIf="observer.role !== 'moderator'">
                        <th class="p-text-center" style="width: 10%" [hidden]="auth.isMe(observer.hashed_id)">
                          <span [class.silent]="observer.type !== 'active'">{{ observer.lastname }}</span>
                        </th>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-competence let-expanded="expanded">
                <tr>
                  <td>
                    <button
                      *ngIf="competence.pivot?.behavioranchors?.length > 0"
                      type="button"
                      pButton
                      pRipple
                      [pRowToggler]="competence"
                      class="p-button-text p-button-rounded p-button-plain"
                      [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    ></button>
                  </td>
                      <td>{{ competence.getLang("name", language) }}</td>
                  <td class="p-text-right">
                    <app-rating-slider
                      [(value)]="competence.value"
                      [min]="ratingtype.min_value"
                      [max]="ratingtype.max_value"
                      [step]="ratingtype.step"
                      (userChange)="saveRating()"
                      [disabled]="!isActive()"
                    ></app-rating-slider>
                  </td>
                  <ng-container *ngIf="auth.isModerator() && withObservers && foreignRatings !== null">
                    <ng-container *ngFor="let observer of ac.observers">
                      <ng-container *ngIf="observer.role !== 'moderator'">
                        <td class="p-text-center foreign-value" style="width: 10%" [hidden]="auth.isMe(observer.hashed_id)">
                          <span *ngIf="observer.type === 'active'" [innerHtml]="getForeignValue(observer.hashed_id, competence)"></span>
                          <ng-container *ngIf="observer.type !== 'active'">
                            <fa-icon [icon]="faBan"></fa-icon>
                          </ng-container>
                        </td>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tr>
              </ng-template>

              <ng-template pTemplate="rowexpansion" let-competence>
                <tr class="behavioranchors">
                  <td [attr.colspan]="2 + (auth.isModerator() ? ac.observers.length : 1)" style="padding: 0">
                    <p-table [value]="competence.pivot.behavioranchors" dataKey="id" styleClass="p-datatable-sm">
                      <ng-template pTemplate="body" let-behavioranchor>
                        <tr class="behavioranchors">
                          <td style="width: 3rem"></td>
                          <td class="behavioranchor">{{ behavioranchor.content }}</td>
                          <td class="p-text-right" style="width: 25%">
                            <app-rating-slider
                              [(value)]="behavioranchor.value"
                              [min]="ratingtype.min_value"
                              [max]="ratingtype.max_value"
                              [step]="ratingtype.step"
                              [type]="SliderTypes.Behavioranchor"
                              (valueChange)="calcCompetence(competence)"
                              (userChange)="saveRating()"
                              [disabled]="!isActive()"
                            ></app-rating-slider>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <div *ngIf="this.ratingtype.getLang('legend', language)" class="legend">
              <h2>{{ t("legend") }}</h2>
              <p [innerHtml]="this.ratingtype.getLang('legend', language) | nl2br"></p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</ng-container>
